import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'
//CODICE VECCHIO DELONGHI

const NumberIcon = ({number, ...props}) => {
    return (
        <Box
            borderRadius="full"
            border="1px solid"
            borderColor={'border.dark'}
            backgroundColor={'background.default'}
            width="2.5rem"
            height="2.5rem"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            lineHeight="1em"
            flexShrink={0}
            verticalAlign="middle"
            color={'border.dark'}
            {...props}
        >
            <Text fontSize="lg" fontWeight="normal">
                {number}
            </Text>
        </Box>
    )
}

NumberIcon.propTypes = {
    number: PropTypes.any,
}

export default NumberIcon
